
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/technical-error",
      function () {
        return require("private-next-pages/technical-error.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/technical-error"])
      });
    }
  